import { Observable } from 'rxjs'

import { AbstractApiDataSource } from '@app/core/services/abstract-api.datasource'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { FormGroup } from '@angular/forms'
import { ServiceRecordService } from './service-record.service'
import { ServiceRecordRow } from './service-record.model'

export class ServiceRecordListDatasource extends AbstractApiDataSource<ServiceRecordRow> {
  constructor(
    protected reminderId: number,
    protected serviceRecordService: ServiceRecordService,
    sort: MatSort,
    paginator: MatPaginator,
    form: FormGroup,
  ) {
    super(sort, paginator, form)
  }

  getApiData(sortValue: string, filterValues: { [p: string]: string | number }): Observable<ServiceRecordRow[]> {
    return this.serviceRecordService.getList(
      this.reminderId,
      this.paginator.pageIndex + 1,
      this.paginator.pageSize,
      sortValue,
      filterValues,
    ) as any
  }
}
